import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 平台人员数据
export function queryorgperson () {
  return request({
    url: '/queryorgperson',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新建人员
export function addorgperson (data) {
  return request({
    url: '/addorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新人员
export function updateorgperson (data) {
  return request({
    url: '/updateorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除人员
export function deleteorgperson (data) {
  return request({
    url: '/deleteorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/orguser.js